(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["moksh-buy-dialog"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{const buy=event.target.closest('[data-mc-buy]');if(buy&&!buy.disabled){const root=buy.closest('.md-home,.ms-shop,.mdp'),dialog=root.querySelector('.mb-dialog');if(!dialog||dialog.dataset.submitting==='true')return;const productForm=buy.dataset.productForm?document.getElementById(buy.dataset.productForm):null;const quantity=Number(productForm?.querySelector('[name="quantity"]')?.value||1);if(productForm&&!productForm.reportValidity())return;if(!Number.isSafeInteger(quantity)||quantity<1)return;dialog.dataset.quantity=String(quantity);dialog.dataset.variant=productForm?.querySelector('[name="id"]')?.value||buy.dataset.variant;const intent=dialog.dataset.variant+':'+quantity;if(dialog.dataset.pendingIntent!==intent){dialog.dataset.added='false';dialog.dataset.pendingIntent=intent;}dialog.querySelector('[data-mb-product]').textContent=buy.dataset.title+(quantity>1?' × '+quantity:'');dialog.querySelector('[data-mb-error]').hidden=true;dialog.querySelector('.mb-continue').disabled=false;dialog.showModal();}const close=event.target.closest('[data-mb-close]');if(close)close.closest('dialog').close();});
document.addEventListener('submit', async event => {
  const form = event.target.closest('[data-mb-form]');
  if (!form) return;
  event.preventDefault();
  const dialog = form.closest('dialog');
  const button = form.querySelector('.mb-continue');
  const error = form.querySelector('[data-mb-error]');
  if (button.disabled || dialog.dataset.submitting === 'true') return;
  const gift = form.querySelector('input[name="attributes[Free gift]"]:checked');
  const card = form.querySelector('[data-art-choice]:checked');
  if (!gift || !card) {
    form.reportValidity();
    return;
  }
  const giftValue = gift.value;
  const cardValue = card.value;
  const cardCode = card.dataset.cardCode;
  dialog.dataset.submitting = 'true';
  button.disabled = true;
  form.inert = true;
  error.hidden = true;
  let noteLock;
  try {
    const giftOrder = await import(dialog.dataset.giftHelper);
    noteLock = giftOrder.lockCustomerNote();
    await noteLock.settle();
    const base = form.action.replace(/\/$/, '');
    if (dialog.dataset.added !== 'true') {
      const response = await fetch(base + '/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: dialog.dataset.variant, quantity: Number(dialog.dataset.quantity || 1) }] }),
      });
      if (!response.ok) throw new Error('cart');
      dialog.dataset.added = 'true';
    }
    await giftOrder.saveGiftSelection(base, giftValue, cardValue, cardCode, noteLock.note);
    dialog.dataset.added = 'false';
    delete dialog.dataset.pendingIntent;
    dialog.dataset.submitting = 'false';
    location.assign(base);
  } catch (failure) {
    dialog.dataset.submitting = 'false';
    error.textContent = form.dataset.error;
    error.hidden = false;
    button.disabled = false;
  } finally {
    noteLock?.unlock();
    form.inert = false;
  }
});
window.addEventListener('pageshow', () => document.querySelectorAll('.mb-continue').forEach(button => {
  const pending = button.closest('dialog')?.dataset.submitting === 'true';
  button.disabled = pending;
  button.closest('form').inert = pending;
}));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["moksh-devotional-card"] && !Shopify.designMode) return;
  try {
    function updateMokshCard(root,close){const selected=root.querySelector('[data-art-choice]:checked'),preview=root.querySelector('[data-art-preview]'),status=root.querySelector('[data-art-status]');if(!selected)return;const image=selected.closest('label').querySelector('img');if(image){preview.src=image.currentSrc||image.src;preview.hidden=false;}status.textContent=status.dataset.selectedText;if(close){root.querySelector('details').open=false;root.querySelector('summary').focus();}}
document.querySelectorAll('[data-art-picker]').forEach(root=>updateMokshCard(root,false));
document.addEventListener('moksh:cart-gifts-restored',()=>document.querySelectorAll('[data-gift-cart] [data-art-picker]').forEach(root=>updateMokshCard(root,false)));
document.addEventListener('change',event=>{if(event.target.matches('[data-art-choice]'))updateMokshCard(event.target.closest('[data-art-picker]'),true);});
document.addEventListener('invalid',event=>{if(event.target.matches('[data-art-choice]')){const root=event.target.closest('[data-art-picker]');root.querySelector('details').open=true;root.querySelector('[data-art-status]').textContent=root.dataset.artError;}},true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["moksh-free-gift"] && !Shopify.designMode) return;
  try {
    let mokshGiftSaveQueue = Promise.resolve();
let mokshGiftSaveSignature = '';
let mokshGiftLatestAttributes = {};
let mokshCartNavigationPending = false;
let mokshCartUnlock = null;
let mokshGiftNoteUnlock = null;

function showMokshGiftSaveError(fallbackRoot) {
  const root = document.querySelector('[data-gift-cart]') || fallbackRoot;
  const error = root?.querySelector('[data-gift-error]');
  if (!error) return;
  error.textContent = root.dataset.checkoutError;
  error.hidden = false;
}

function saveMokshCartGiftChoices() {
  const root = document.querySelector('[data-gift-cart]');
  if (!root) return mokshGiftSaveQueue;
  const gift = root.querySelector('input[name="attributes[Free gift]"]:checked');
  const card = root.querySelector('[data-art-choice]:checked');
  const attributes = {};
  if (gift) attributes['Free gift'] = gift.value;
  if (card) attributes['Devotional art card'] = card.value;
  if (!Object.keys(attributes).length) return mokshGiftSaveQueue;
  mokshGiftLatestAttributes = attributes;
  const signature = JSON.stringify(attributes);
  if (signature === mokshGiftSaveSignature) return mokshGiftSaveQueue;
  mokshGiftSaveSignature = signature;
  const base = root.dataset.cartUrl;
  mokshGiftSaveQueue = mokshGiftSaveQueue.catch(() => {}).then(async () => {
    const response = await fetch(base + '/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes }),
    });
    if (!response.ok) throw new Error('attributes');
  }).catch(error => {
    if (mokshGiftSaveSignature === signature) mokshGiftSaveSignature = '';
    throw error;
  });
  return mokshGiftSaveQueue;
}

async function settleMokshCart() {
  await saveMokshCartGiftChoices();
  for (const component of document.querySelectorAll('cart-items-component')) {
    await component.settlePendingUpdates?.();
  }
  await saveMokshCartGiftChoices();
}

function lockMokshCart() {
  const components = Array.from(document.querySelectorAll('cart-items-component, [data-gift-cart]'));
  const states = components.map(component => component.inert);
  components.forEach(component => { component.inert = true; });
  mokshCartUnlock = () => components.forEach((component, index) => { component.inert = states[index]; });
  return mokshCartUnlock;
}

window.addEventListener('pageshow', event => {
  if (event.persisted) {
    location.reload();
    return;
  }
  if (!mokshCartNavigationPending) return;
  mokshCartNavigationPending = false;
  mokshCartUnlock?.();
  mokshGiftNoteUnlock?.();
  document.querySelectorAll('button[name="checkout"][form="cart-form"], #cart-form button[name="checkout"]').forEach(button => {
    button.disabled = false;
  });
});

document.addEventListener('moksh:cart-rendered', () => {
  const root = document.querySelector('[data-gift-cart]');
  if (!root) return;
  for (const [key, value] of Object.entries(mokshGiftLatestAttributes)) {
    for (const input of root.querySelectorAll('input[type="radio"]')) {
      if (input.name === 'attributes[' + key + ']') input.checked = input.value === value;
    }
  }
  document.dispatchEvent(new CustomEvent('moksh:cart-gifts-restored'));
});

document.addEventListener('change', event => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || !input.closest('[data-gift-cart]')) return;
  if (input.name !== 'attributes[Free gift]' && !input.matches('[data-art-choice]')) return;
  const root = input.closest('[data-gift-cart]');
  root.querySelector('[data-gift-error]').hidden = true;
  saveMokshCartGiftChoices().catch(() => showMokshGiftSaveError(root));
});

document.addEventListener('moksh:save-cart-gifts', event => {
  const pending = saveMokshCartGiftChoices();
  event.detail.waitUntil(pending);
  pending.catch(() => showMokshGiftSaveError());
});

document.addEventListener('click', async event => {
  const link = event.target instanceof Element ? event.target.closest('.cart-page__add-more') : null;
  if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  event.preventDefault();
  if (mokshCartNavigationPending) return;
  mokshCartNavigationPending = true;
  const root = document.querySelector('[data-gift-cart]');
  const unlock = lockMokshCart();
  try {
    await settleMokshCart();
    location.assign(link.href);
  } catch (error) {
    showMokshGiftSaveError(root);
    mokshCartNavigationPending = false;
    unlock();
  }
});

document.addEventListener('submit', async event => {
  const form = event.target;
  if (form.id !== 'cart-form' || event.submitter?.name !== 'checkout') return;
  const root = document.querySelector('[data-gift-cart]');
  if (!root) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  const button = event.submitter;
  if (button.disabled || mokshCartNavigationPending) return;
  const gift = root.querySelector('input[name="attributes[Free gift]"]:checked');
  const card = root.querySelector('[data-art-choice]:checked');
  if (!gift || !card) {
    form.reportValidity();
    return;
  }
  const giftValue = gift.value;
  const cardValue = card.value;
  const cardCode = card.dataset.cardCode;
  const base = root.dataset.cartUrl;
  button.disabled = true;
  root.querySelector('[data-gift-error]').hidden = true;
  mokshCartNavigationPending = true;
  const unlock = lockMokshCart();
  try {
    const giftOrder = await import(root.dataset.giftHelper);
    const noteLock = giftOrder.lockCustomerNote(form);
    mokshGiftNoteUnlock = noteLock.unlock;
    await settleMokshCart();
    await noteLock.settle();
    await giftOrder.saveGiftSelection(base, giftValue, cardValue, cardCode, noteLock.note);
    location.assign(base.replace(/cart$/, 'checkout'));
  } catch (error) {
    if (error.message === 'empty-cart') {
      location.assign(base);
      return;
    }
    showMokshGiftSaveError(root);
    mokshCartNavigationPending = false;
    unlock();
    mokshGiftNoteUnlock?.();
    document.querySelectorAll('#cart-form button[name="checkout"], button[name="checkout"][form="cart-form"]').forEach(control => {
      control.disabled = false;
    });
    button.disabled = false;
  }
}, true);
  } catch(e) { console.error(e); }
})();

})();
